import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import { Actions, Mutations } from "@/store/enums/StoreEnums";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/propositions",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "/propositions/:id/editer",
        name: "app-proposals-edit",
        component: () =>
          import("@/views/apps/subscriptions/EditSubscription.vue"),
      },
      {
        path: "/accessoires/ajouter",
        name: "app-accessoires-ajouter",
        component: () =>
          import("@/views/apps/accessoires/AccessoiresCreatePage.vue"),
      },
      {
        path: "/accessoires/:id/editer",
        name: "app-accessoires-editer",
        component: () =>
          import("@/views/apps/accessoires/AccessoiresModifierPage.vue"),
      },
    ],
  },
  {
    path: "/",
    redirect: "/404",
    component: () => import("@/layout/AppLayout.vue"),
    children: [
      {
        path: "/accessoires",
        name: "app-accessoires-liste",
        component: () =>
          import("@/views/apps/accessoires/AccessoiresListePage.vue"),
      },
      {
        path: "/commandes",
        name: "app-commandes-liste",
        component: () =>
          import("@/views/apps/commandes/CommandesListePage.vue"),
      },
      {
        path: "/fonds-studio",
        name: "app-carbackground-tableau-de-bord",
        component: () =>
          import(
            "@/views/apps/carbackground/CarBackgroundTableauDeBordPage.vue"
          ),
      },
      {
        path: "/catalogue",
        name: "app-catalogue-liste",
        component: () =>
          import("@/views/apps/catalogue/CatalogueListePage.vue"),
      },
      {
        path: "/catalogue/ajouter",
        name: "app-catalogue-ajouter",
        component: () =>
          import("@/views/apps/catalogue/CatalogueCreatePage.vue"),
      },
      {
        path: "/catalogue/:id/editer",
        name: "app-catalogue-editer",
        component: () => import("@/views/apps/catalogue/CatalogueEditPage.vue"),
      },
      {
        path: "/propositions/livres",
        name: "app-propositions-livres-liste",
        component: () =>
          import("@/views/apps/propositions/LivresListePage.vue"),
      },
      {
        path: "/lavages",
        name: "app-lavages-liste",
        component: () => import("@/views/apps/commandes/LavageListePage.vue"),
      },
      {
        path: "/prospects",
        name: "app-prospects-liste",
        component: () =>
          import("@/views/apps/prospects/ProspectsListePage.vue"),
      },
      {
        path: "/caisses",
        name: "app-caisses-liste",
        component: () => import("@/views/apps/caisses/CaissesListePage.vue"),
      },
      {
        path: "/propositions",
        name: "app-propositions-liste",
        component: () =>
          import("@/views/apps/propositions/PropositionsListePage.vue"),
      },
      {
        path: "/vehicules",
        name: "app-vehicules-liste",
        component: () =>
          import("@/views/apps/vehicules/VehiculesListePage.vue"),
      },
      {
        path: "/vehicules/stock",
        name: "app-vehicules-stock",
        component: () =>
          import("@/views/apps/vehicules/VehiculesStockPage.vue"),
      },
      {
        // Meme page servie par l'api-v2 (SQL Server) au lieu de Typesense, le
        // temps de comparer les deux avant de basculer.
        path: "/vehicules/stock-sql",
        name: "app-vehicules-stock-sql",
        component: () =>
          import("@/views/apps/vehicules/VehiculesStockSqlPage.vue"),
      },
      {
        path: "/vehicules/ajouter",
        name: "app-vehicules-ajouter",
        component: () =>
          import("@/views/apps/vehicules/VehiculesCreatePage.vue"),
      },
      {
        path: "/vehicules/:id",
        name: "app-vehicules-details",
        component: () =>
          import("@/views/apps/vehicules/VehiculesDetailsPage.vue"),
      },
      {
        path: "/vehicules/:id/editer",
        name: "app-vehicules-edit",
        component: () => import("@/views/apps/vehicules/VehiculesEditPage.vue"),
      },
      {
        path: "/propositions/:id/editer",
        name: "app-proposals-edit",
        component: () =>
          import("@/views/apps/subscriptions/EditSubscription.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layout/AppPhotosLayout.vue"),
    children: [
      {
        path: "/vehicules/recherche-photos",
        name: "app-vehicules-recherche-photos",
        component: () =>
          import("@/views/apps/vehicules/VehiculeRecherchePhotosPage.vue"),
      },
      {
        path: "/vehicules/gabarits",
        name: "app-vehicules-gabarits",
        component: () =>
          import("@/views/apps/vehicules/VehiculeGabaritsPage.vue"),
      },
      {
        path: "/vehicules/gabarits/dessiner",
        name: "app-vehicules-gabarits-dessiner",
        component: () =>
          import("@/views/apps/vehicules/VehiculeGabaritDessinPage.vue"),
      },
      {
        path: "/vehicules/:id/photos",
        name: "app-vehicules-photos",
        component: () =>
          import("@/views/apps/vehicules/VehiculePhotosCapturePage.vue"),
      },
    ],
  },
  {
    path: "/vehicules/:id/affiche",
    name: "app-vehicules-affiche",
    component: () => import("@/views/apps/vehicules/VehiculesAffichePage.vue"),
  },
  {
    path: "/",
    component: () => import("@/layout/AppEmptyLayout.vue"),
    children: [
      {
        path: "/se-connecter",
        name: "sign-in",
        component: () => import("@/views/apps/auth/SeConnecter.vue"),
      },
      {
        path: "/404",
        name: "404",
        component: () => import("@/views/apps/NotFound.vue"),
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layout/AppPrintLayout.vue"),
    children: [
      {
        path: "/vehicules/:id/fiche-clef",
        name: "app-vehicules-fiche-clef",
        component: () =>
          import("@/views/apps/vehicules/VehiculesFicheClefPage.vue"),
      },
      {
        path: "/vehicules/:id/fiche-preparation-vo",
        name: "app-vehicules-fiche-preparation-vo",
        component: () =>
          import("@/views/apps/vehicules/VehiculesFichePreparationVoPage.vue"),
      },
      {
        path: "/propositions/:id/fiche-preparation-vehicule",
        name: "app-proposals-fiche-preparation-vehicule",
        component: () =>
          import(
            "@/views/apps/subscriptions/PropositionFichePreparationVehiculePage.vue"
          ),
      },
      {
        path: "/propositions/:id/fiche-vehicule-vendu",
        name: "app-proposals-fiche-vehicule-vendu",
        component: () =>
          import(
            "@/views/apps/subscriptions/PropositionFicheVehiculeVenduPage.vue"
          ),
      },
      {
        path: "/vehicules/:id/fiche-reception",
        name: "app-vehicules-fiche-reception",
        component: () =>
          import("@/views/apps/vehicules/VehiculesFicheReceptionPage.vue"),
      },
      {
        path: "/vehicules/:id/fiche-suivi",
        name: "app-vehicules-fiche-suivi",
        component: () =>
          import("@/views/apps/vehicules/VehiculesFicheSuiviPage.vue"),
      },
    ],
  },
  {
    path: "/propositions/:id/pdf",
    name: "app-proposition-pdf",
    component: () => import("@/views/apps/propositions/PropositionPdfPage.vue"),
  },
  {
    path: "/propositions/:id/bon-de-commande-pdf",
    name: "app-proposition-bon-de-commande-pdf",
    component: () =>
      import("@/views/apps/propositions/PropositionBonDeCommandePdfPage.vue"),
  },
  // Pages publiques adressees par uuid : ce sont les liens envoyes au client.
  // Memes chemins courts que le site (`/p/`, `/b/`), pour que les liens deja
  // diffuses par eGesparc et Bitrix restent valables.
  {
    path: "/p/:uuid",
    name: "proposition-publique",
    component: () =>
      import("@/views/apps/propositions/publique/PropositionPubliquePage.vue"),
  },
  {
    path: "/b/:uuid",
    name: "proposition-publique-bon-de-commande",
    component: () =>
      import(
        "@/views/apps/propositions/publique/BonDeCommandePubliquePage.vue"
      ),
  },
  {
    path: "/500",
    name: "500",
    component: () => import("@/views/crafted/authentication/Error500.vue"),
  },
  // Banc d'essai du positionneur de plaque, sans reprendre de photo. Page hors
  // layout, comme le viseur ; l'envoi a l'API y est reserve aux admins.
  {
    path: "/simulation-plaque",
    name: "simulation-plaque",
    component: () =>
      import("@/views/apps/vehicules/VehiculeSimulationPlaquePage.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({
            el: to.hash,
            behavior: "smooth",
          });
        }, 2000);
      });
    }
  },
});

// Routes servies sans authentification : ecran de connexion, pages rendues pour
// la generation des PDF, et les deux documents que le client consulte depuis son
// lien (il n'a pas de compte eGesparc).
export const ROUTES_PUBLIQUES = [
  "sign-in",
  "app-proposition-pdf",
  "app-proposition-bon-de-commande-pdf",
  "proposition-publique",
  "proposition-publique-bon-de-commande",
];

router.beforeEach((to, from) => {
  if (!ROUTES_PUBLIQUES.includes(to.name as string)) {
    store.commit("setRedirectUrl", to.fullPath);
    store.dispatch(Actions.VERIFY_AUTH);
  }

  store.commit(Mutations.RESET_LAYOUT_CONFIG);

  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

export default router;
